import { Errno } from '../domain/Errno'

export function getSDK() {
  const { TPDirect } = window
  if (!TPDirect) {
    throw new Error('TapPay SDK not loaded')
  }
  return TPDirect
}

// * https://docs.tappaysdk.com/tutorial/zh/web/front.html
// * https://github.com/TapPay/tappay-web-example/tree/master/TapPay_Fields

export function setupSDK(config) {
  const TPDirect = getSDK()
  TPDirect.setupSDK(config.app_id, config.app_key, config.server_type)
}

export function setupCard(config) {
  const TPDirect = getSDK()
  TPDirect.card.setup({
    fields: config.fields,
    styles: config.styles,
  })
  TPDirect.card.onUpdate(config.onUpdate)
}

export function getPrime() {
  return new Promise((resolve, reject) => {
    const TPDirect = getSDK()
    if (!TPDirect.card.getTappayFieldsStatus().canGetPrime) {
      return reject('cannot get prime')
    }
    TPDirect.card.getPrime(result => {
      /*
       result: {
         "status": 0,
         "msg": "Success",
         "card": {
           "prime": "33c47f94d3041cf3f2922c0f4dc745f07f32711c04a5890cfa3b493a928fe7fd",
           "issuer": "",
           "lastfour": "4242",
           "bincode": "424242",
           "funding": 0,
           "type": 1,
           "level": "",
           "country": "UNITED KINGDOM",
           "countrycode": "GB"
          },
          "clientip": "111.241.119.235",
          "card_identifier": "65f88192c1ff4d6899b69ed7c7b321ca"
        }
      */
      if (result.status !== 0) {
        return reject(result.msg)
      }
      resolve({
        prime: result.card.prime,
        clientip: result.clientip,
        card_identifier: result.card_identifier,
        // TODO [future] card info?
      })
    })
  })
}

export function isTapPayErrorFailure(status, errno) {
  if (status < 500) {
    return true
  }

  switch (errno) {
    case Errno.ERR_TAPPAY_CREDIT_CARD_EXPIRED:
    case Errno.ERR_TAPPAY_REQUEST_FAILED:
    case Errno.ERR_TAPPAY_AMOUNT_MISMATCH:
    case Errno.ERR_TAPPAY_UNRECOGNIZED_ERROR:
    case Errno.ERR_AIFIAN_PAYMENT_SERVICE_CREAM_INSTALMENT_PAYMENT_DENIED:
    case Errno.ERR_AIFIAN_PAYMENT_SERVICE_CREAM_DISCOUNT_MISMATCH:
      return true
    default:
      return false
  }
}
